export default __webpack_public_path__ + "f9fa9a7e4c815805d54cc58ed34bf4bf.png";